import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C11ReverseRowStoriesProps = RenderingProps<
  C11ReverseRowStoriesFields,
  C11ReverseRowStoriesRenderingParams
>;

export type C11ReverseRowStoriesFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
  CTA?: LinkField;
};

export type C11ReverseRowStoriesRenderingParams = {
  HeadlineTag?: string;
  RemovePaddingBetweenRows?: boolean;
  CtaStyle?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  ImagePropertiesParams;
